import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";
import useScrollReveal from "../hooks/useScrollReveal";
import { isAdminRole } from "../utils/roles";

export default function LoginPage() {
  const { login } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();
  const revealRef = useScrollReveal();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Where to go after login: the page the user came from, or home
  const from = location.state?.from || "/";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(isAdminRole(user.role) ? "/admin" : from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || t.login_error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div ref={revealRef} className="dept-auth-page">
      <div className="dept-auth-shell page-enter">
        <div className="dept-auth-heading">
          <span>회원 서비스</span>
          <h1>{t.login_heading}</h1>
          <p>{t.login_subtitle}</p>
        </div>

        {error && <div className="dept-auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="dept-auth-form">
          <div className="dept-auth-field">
            <label>{t.login_email}</label>
            <input type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="example@email.com" />
          </div>
          <div className="dept-auth-field">
            <label>{t.login_password}</label>
            <input type="password" required value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder={t.login_pwPlaceholder} />
          </div>
          <button type="submit" disabled={loading} className="dept-auth-submit">
            {loading ? t.login_submitting : t.login_emailLogin}
          </button>
        </form>

        <p className="dept-auth-switch">
          {t.login_noAccount}{" "}
          <Link to="/signup">{t.login_signup}</Link>
        </p>
      </div>
    </div>
  );
}
